import React from 'react';
import { Box } from '@mui/material';

const BentoItem = ({ children, colSpan, rowSpan, colStart, rowStart, gap, sx = {}, ...rest }) => {
  // Helper to handle responsive colSpan/rowSpan using MUI's sx breakpoint syntax
  const getResponsiveGridValue = (value, start) => {
    if (typeof value === 'object' && value !== null) {
      const result = {};
      Object.entries(value).forEach(([breakpoint, v]) => {
        result[breakpoint] = start ? `${start} / span ${v}` : `span ${v}`;
      });
      return result;
    }
    return start ? `${start} / span ${value}` : `span ${value}`;
  };

  const gridStyles = {
    ...(colSpan !== undefined && { gridColumn: getResponsiveGridValue(colSpan, colStart) }),
    ...(rowSpan !== undefined && { gridRow: getResponsiveGridValue(rowSpan, rowStart) }),
    ...(gap !== undefined && { gap }),
    ...sx,
  };

  return (
    <Box sx={{ ...gridStyles, display: 'flex' }} {...rest}>
      {children}
    </Box>
  );
};

export default BentoItem;
